module.exports = __webpack_public_path__ + "img/offline-status.55170a39.svg";